<template>
    <span
        class="badge badge-large badge-purple mb-1 mr-1 cursor-pointer"
        @click="onClick"
    >
        {{value.value}}
    </span>
</template>

<script>
  export default {
    props: ['value'],

    methods: {
      /**
       * @return {undefined}
       */
      onClick() {

        this.$emit('select', this.value.value);
      },
    },
  }
</script>



